// extracted by mini-css-extract-plugin
export var csatScore = "_j2-5";
export var header = "_j2-1";
export var panelWrapper = "_j2-2";
export var postPreview = "_j2-3";
export var rightContent = "_j2-0";
export var wrappingText = "_j2-4";